import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheckIcon, MapPinIcon } from 'lucide-react';
export function CuraSection() {
  const containerVariants = {
    hidden: {
      opacity: 0
    },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.2
      }
    }
  };
  const itemVariants = {
    hidden: {
      opacity: 0,
      y: 30
    },
    visible: {
      opacity: 1,
      y: 0,
      transition: {
        duration: 0.6,
        ease: 'easeOut'
      }
    }
  };
  return <section className="py-24 bg-brand-darker relative border-t border-white/5" data-id="element-110">
      {/* Subtle background glow */}
      <div className="absolute bottom-0 left-1/4 w-96 h-96 bg-brand-green/10 rounded-full blur-[120px] pointer-events-none" data-id="element-111" />

      <div className="container mx-auto px-6 md:px-12 relative z-10" data-id="element-112">
        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="text-center mb-16" data-id="element-113">
          <motion.h2 variants={itemVariants} className="font-heading text-brand-yellow text-sm md:text-base tracking-[0.3em] uppercase mb-4" data-id="element-114">
            La Cura
          </motion.h2>
          <motion.h3 variants={itemVariants} className="font-heading text-3xl md:text-5xl font-bold text-white" data-id="element-115">
            Nuestro tratamiento para tu negocio
          </motion.h3>
        </motion.div>

        <motion.div initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-100px'
      }} variants={containerVariants} className="grid grid-cols-1 md:grid-cols-2 gap-8 max-w-5xl mx-auto" data-id="element-116">
          {/* Card 1 */}
          <motion.div variants={itemVariants} className="group bg-brand-black border border-white/5 p-10 rounded-xl hover:border-brand-green/50 transition-all duration-500 relative overflow-hidden shadow-lg" data-id="element-117">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-green to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-118" />

            <div className="w-14 h-14 rounded-full bg-brand-green/10 flex items-center justify-center mb-6 border border-brand-green/30 group-hover:scale-110 group-hover:bg-brand-green/20 transition-all duration-500" data-id="element-119">
              <ShieldCheckIcon className="w-6 h-6 text-brand-green" data-id="element-120" />
            </div>

            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-121">
              Landing de Confianza Total
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-122">
              Enfocada en la seguridad de la familia y mascotas, diseñada
              psicológicamente para garantizar la conversión de visitantes a
              clientes.
            </p>
          </motion.div>

          {/* Card 2 */}
          <motion.div variants={itemVariants} className="group bg-brand-black border border-white/5 p-10 rounded-xl hover:border-brand-green/50 transition-all duration-500 relative overflow-hidden shadow-lg" data-id="element-123">
            <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-brand-green to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-500" data-id="element-124" />

            <div className="w-14 h-14 rounded-full bg-brand-green/10 flex items-center justify-center mb-6 border border-brand-green/30 group-hover:scale-110 group-hover:bg-brand-green/20 transition-all duration-500" data-id="element-125">
              <MapPinIcon className="w-6 h-6 text-brand-green" data-id="element-126" />
            </div>

            <h4 className="font-heading text-2xl font-bold text-white mb-4" data-id="element-127">
              Ads por Código Postal
            </h4>
            <p className="text-brand-gray leading-relaxed" data-id="element-128">
              Bombardeamos solo las zonas donde hay más reportes de plagas o
              casas de alto valor. Precisión quirúrgica para maximizar tu ROI.
            </p>
          </motion.div>
        </motion.div>
      </div>
    </section>;
}